import Option from '@/modules/common/models/option/option.ts';

export default class TypeOption extends Option<string> {
  constructor(response: unknown) {
    super(response, 'Тип', 'Тип');
  }
}
